import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from "react";
import { Utils } from "@react-awesome-query-builder/core";
import PropTypes from "prop-types";
import { truncateString } from "../../utils/stuff";
import { useOnPropsChanged } from "../../utils/reactUtils";
import last from "lodash/last";
import keys from "lodash/keys";
var getFieldPathLabels = Utils.RuleUtils.getFieldPathLabels;
var _Utils$ConfigUtils = Utils.ConfigUtils,
  getFieldConfig = _Utils$ConfigUtils.getFieldConfig,
  getFieldParts = _Utils$ConfigUtils.getFieldParts,
  getFieldPathParts = _Utils$ConfigUtils.getFieldPathParts;
var Field = /*#__PURE__*/function (_Component) {
  _inherits(Field, _Component);
  var _super = _createSuper(Field);
  function Field(props) {
    var _this;
    _classCallCheck(this, Field);
    _this = _super.call(this, props);
    useOnPropsChanged(_assertThisInitialized(_this));
    _this.onPropsChanged(props);
    return _this;
  }
  _createClass(Field, [{
    key: "onPropsChanged",
    value: function onPropsChanged(nextProps) {
      var prevProps = this.props;
      var keysForMeta = ["selectedField", "selectedFieldSrc", "selectedFieldType", "config", "parentField"];
      var needUpdateMeta = !this.meta || keysForMeta.map(function (k) {
        return nextProps[k] !== prevProps[k];
      }).filter(function (ch) {
        return ch;
      }).length > 0;
      if (needUpdateMeta) {
        this.meta = this.getMeta(nextProps);
      }
    }
  }, {
    key: "getMeta",
    value: function getMeta(_ref) {
      var selectedField = _ref.selectedField,
        selectedFieldType = _ref.selectedFieldType,
        config = _ref.config,
        parentField = _ref.parentField;
      var selectedKey = selectedField;
      var _config$settings = config.settings,
        maxLabelsLength = _config$settings.maxLabelsLength,
        fieldSeparatorDisplay = _config$settings.fieldSeparatorDisplay,
        fieldPlaceholder = _config$settings.fieldPlaceholder,
        fieldSeparator = _config$settings.fieldSeparator;
      var isFieldSelected = !!selectedField;
      var placeholder = !isFieldSelected ? truncateString(fieldPlaceholder, maxLabelsLength) : null;
      var currField = isFieldSelected ? getFieldConfig(config, selectedKey) : null;
      var selectedOpts = currField || {};
      var selectedKeys = getFieldPathParts(selectedKey, config);
      var selectedPath = getFieldPathParts(selectedKey, config, true);
      var selectedLabel = this.getFieldLabel(currField, selectedKey, config);
      var partsLabels = getFieldPathLabels(selectedKey, config);
      var selectedFullLabel = partsLabels ? partsLabels.join(fieldSeparatorDisplay) : null;
      if (selectedFullLabel == selectedLabel || parentField) selectedFullLabel = null;
      var selectedAltLabel = selectedOpts.label2;
      var parentFieldPath = getFieldParts(parentField, config);
      var parentFieldConfig = parentField ? getFieldConfig(config, parentField) : null;
      var sourceFields = parentField ? parentFieldConfig && parentFieldConfig.subfields : config.fields;
      var lookingForFieldType = !isFieldSelected && selectedFieldType;
      var items = this.buildOptions(parentFieldPath, config, sourceFields, lookingForFieldType, parentFieldPath);

      // Field source has been chnaged, no new field selected, but op & value remains
      var errorText = lookingForFieldType ? "Please select field" : null;
      return {
        placeholder: placeholder,
        items: items,
        parentField: parentField,
        selectedKey: selectedKey,
        selectedKeys: selectedKeys,
        selectedPath: selectedPath,
        selectedLabel: selectedLabel,
        selectedOpts: selectedOpts,
        selectedAltLabel: selectedAltLabel,
        selectedFullLabel: selectedFullLabel,
        errorText: errorText
      };
    }
  }, {
    key: "getFieldLabel",
    value: function getFieldLabel(fieldOpts, fieldKey, config) {
      if (!fieldKey) return null;
      var maxLabelsLength = config.settings.maxLabelsLength;
      var fieldParts = getFieldParts(fieldKey, config);
      var label = (fieldOpts === null || fieldOpts === void 0 ? void 0 : fieldOpts.label) || last(fieldParts);
      label = truncateString(label, maxLabelsLength);
      return label;
    }
  }, {
    key: "buildOptions",
    value: function buildOptions(parentFieldPath, config, fields) {
      var _this2 = this;
      var fieldType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var path = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var optGroupLabel = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      if (!fields) return null;
      var _config$settings2 = config.settings,
        fieldSeparator = _config$settings2.fieldSeparator,
        fieldSeparatorDisplay = _config$settings2.fieldSeparatorDisplay;
      var prefix = path !== null && path !== void 0 && path.length ? path.join(fieldSeparator) + fieldSeparator : "";
      var countFieldsMatchesType = function countFieldsMatchesType(fields) {
        return Object.keys(fields).reduce(function (acc, fieldKey) {
          var field = fields[fieldKey];
          if (field.type === "!struct") {
            return acc + countFieldsMatchesType(field.subfields);
          } else {
            return acc + (field.type === fieldType ? 1 : 0);
          }
        }, 0);
      };
      return keys(fields).map(function (fieldKey) {
        var fullFieldPath = [].concat(_toConsumableArray(path !== null && path !== void 0 ? path : []), [fieldKey]);
        var field = fields[fieldKey];
        var label = _this2.getFieldLabel(field, fullFieldPath, config);
        var partsLabels = getFieldPathLabels(fullFieldPath, config);
        var fullLabel = partsLabels.join(fieldSeparatorDisplay);
        if (fullLabel == label || parentFieldPath !== null && parentFieldPath !== void 0 && parentFieldPath.length) fullLabel = null;
        var altLabel = field.label2;
        var tooltip = field.tooltip;
        var disabled = field.disabled;
        if (field.hideForSelect) return undefined;
        if (field.type == "!struct") {
          var items = _this2.buildOptions(parentFieldPath, config, field.subfields, fieldType, fullFieldPath, label);
          var hasItemsMatchesType = countFieldsMatchesType(field.subfields) > 0;
          return {
            disabled: disabled,
            key: fieldKey,
            path: prefix + fieldKey,
            label: label,
            fullLabel: fullLabel,
            altLabel: altLabel,
            tooltip: tooltip,
            items: items,
            matchesType: hasItemsMatchesType
          };
        } else {
          var matchesType = fieldType !== undefined ? field.type === fieldType : undefined;
          return {
            disabled: disabled,
            key: fieldKey,
            path: prefix + fieldKey,
            label: label,
            fullLabel: fullLabel,
            altLabel: altLabel,
            tooltip: tooltip,
            grouplabel: optGroupLabel,
            matchesType: matchesType
          };
        }
      }).filter(function (o) {
        return !!o;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        config = _this$props.config,
        customProps = _this$props.customProps,
        setField = _this$props.setField,
        setFieldSrc = _this$props.setFieldSrc,
        readonly = _this$props.readonly,
        id = _this$props.id,
        groupId = _this$props.groupId;
      var renderField = config.settings.renderField;
      var renderProps = _objectSpread({
        id: id,
        groupId: groupId,
        config: config,
        customProps: customProps,
        readonly: readonly,
        setField: setField,
        setFieldSrc: setFieldSrc
      }, this.meta);
      return renderField(renderProps, config.ctx);
    }
  }]);
  return Field;
}(Component);
Field.propTypes = {
  id: PropTypes.string,
  groupId: PropTypes.string,
  config: PropTypes.object.isRequired,
  selectedField: PropTypes.any,
  selectedFieldSrc: PropTypes.string,
  selectedFieldType: PropTypes.string,
  parentField: PropTypes.string,
  customProps: PropTypes.object,
  readonly: PropTypes.bool,
  //actions
  setField: PropTypes.func.isRequired,
  setFieldSrc: PropTypes.func
};
export { Field as default };